// test1978
(1978 && 0);
